import { Send } from 'lucide-react';
import { useEffect, useState } from 'react';
import { Empty, Screen } from '../components/ui';
import { sendMessage } from '../lib/actions';
import { db, metaSet, useLive } from '../lib/db';
import { dayTime } from '../lib/format';
import { useActiveTrips } from '../lib/selectors';

/**
 * Разговор с диспечера. Изпратеното без обхват стои в опашката и се вижда като
 * „чака" — точно това липсва при Viber и заради него съобщения се губят.
 */
export function MessagesScreen() {
  const trips = useActiveTrips();
  const tripId = trips[0]?.id ?? null;
  const [text, setText] = useState('');

  const messages = useLive(
    async () => {
      const rows = await db.messages.toArray();
      return rows.sort((a, b) => a.sentAt.localeCompare(b.sentAt));
    },
    [],
    [],
  );

  useEffect(() => {
    void metaSet('messages.readAt', new Date().toISOString());
  }, [messages.length]);

  async function submit() {
    const body = text.trim();
    if (body.length === 0) return;
    setText('');
    await sendMessage(body, tripId);
  }

  return (
    <Screen title="Съобщения" logo>
      {messages.length === 0 ? (
        <Empty>Още няма съобщения.</Empty>
      ) : (
        <ul className="space-y-3 pb-4">
          {messages.map((message) => (
            <li
              key={message.id}
              className={`max-w-[85%] rounded-2xl border-2 p-3 ${
                message.direction === 'out'
                  ? 'ml-auto border-go bg-go/10'
                  : 'mr-auto border-line bg-card'
              }`}
            >
              <div className="text-base font-semibold text-muted">{message.authorName}</div>
              <p className="whitespace-pre-wrap text-xl">{message.body}</p>
              <div className="mt-1 text-base text-muted">
                {dayTime(message.sentAt)}
                {message.pending === 1 ? ' · чака изпращане' : ''}
              </div>
            </li>
          ))}
        </ul>
      )}

      <div className="safe-bottom sticky bottom-0 flex gap-2 bg-paper pt-2">
        <textarea
          value={text}
          onChange={(event) => setText(event.target.value)}
          rows={2}
          maxLength={2000}
          placeholder="Напишете съобщение…"
          className="flex-1 rounded-2xl border-2 border-line bg-paper px-3 py-3 text-xl"
        />
        <button
          type="button"
          onClick={() => void submit()}
          aria-label="Изпрати"
          disabled={text.trim().length === 0}
          className="flex w-20 items-center justify-center rounded-2xl bg-go text-white disabled:opacity-40"
        >
          <Send size={30} />
        </button>
      </div>
    </Screen>
  );
}
